import { useId, type ComponentPropsWithRef, type ReactNode } from 'react';
import { Icon } from '../components';

/** A labelled multi-line input, laid out like TextField. */
export function TextArea({
  label,
  hint,
  error,
  optional,
  required,
  rows = 4,
  id,
  ...rest
}: {
  label: string;
  hint?: ReactNode;
  error?: ReactNode;
  optional?: boolean;
  required?: boolean;
} & ComponentPropsWithRef<'textarea'>) {
  const uid = useId();
  const fid = id ?? uid;
  return (
    <div className={error ? 'rq-field is-invalid' : 'rq-field'}>
      <label htmlFor={fid} className="rq-field-label">
        {label}
        {required ? (
          <span className="rq-field-req"> (required)</span>
        ) : optional ? (
          <span className="rq-field-opt"> (optional)</span>
        ) : null}
      </label>
      <div className="rq-input">
        <textarea
          id={fid}
          rows={rows}
          required={required}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error ? `${fid}-err` : hint ? `${fid}-hint` : undefined}
          {...rest}
        />
      </div>
      {error ? (
        <p className="rq-field-error" id={`${fid}-err`}>
          <Icon name="octagon-alert" size={14} />
          {error}
        </p>
      ) : hint ? (
        <p className="rq-field-hint" id={`${fid}-hint`}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
